import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=9f31bdca&scoped=true"
import script from "./Tip.vue?vue&type=script&lang=js"
export * from "./Tip.vue?vue&type=script&lang=js"
import style0 from "./Tip.vue?vue&type=style&index=0&id=9f31bdca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f31bdca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f31bdca')) {
      api.createRecord('9f31bdca', component.options)
    } else {
      api.reload('9f31bdca', component.options)
    }
    module.hot.accept("./Tip.vue?vue&type=template&id=9f31bdca&scoped=true", function () {
      api.rerender('9f31bdca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tip.vue"
export default component.exports